export const holidayColors = {
  person1: {
    holiday: 'bg-red-500',
    bridge: 'bg-orange-400',
    school: 'bg-indigo-500',
    vacation: 'bg-emerald-200',
    ui: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-600',
      hover: 'hover:bg-emerald-100',
      focus: 'focus:ring-emerald-500',
      border: 'border-emerald-500',
      checked: 'peer-checked:bg-emerald-500'
    }
  },
  person2: {
    holiday: 'bg-cyan-500',
    bridge: 'bg-cyan-400',
    school: 'bg-cyan-600',
    vacation: 'bg-cyan-200',
    ui: {
      bg: 'bg-cyan-50',
      text: 'text-cyan-600',
      hover: 'hover:bg-cyan-100',
      focus: 'focus:ring-cyan-500',
      border: 'border-cyan-500',
      checked: 'peer-checked:bg-cyan-500'
    }
  }
};

export const gradientColors = {
  shared: {
    holiday: 'bg-gradient-to-r from-red-500 to-cyan-500',
    bridge: 'bg-gradient-to-r from-orange-400 to-cyan-400',
    school: 'bg-gradient-to-r from-indigo-500 to-cyan-600',
    vacation: 'bg-gradient-to-r from-emerald-500 to-cyan-500'
  }
}; 